// Note: if variant options change in Contentful, the options must be updated here too

export const superHeroVariants = [
  {
    option: "Side Margins, 2/3 Media, Image Left, 405px Max Ht",
    variant: "variant_1",
    contentSide: "right",
    padding: true,
    fullBleedColor: true,
  },
  {
    option: "Side Margins, 2/3 Media, Image Right, 405px Max Ht",
    variant: "variant_1",
    contentSide: "left",
    padding: true,
    fullBleedColor: true,
  },
  {
    option: "Side Margins, 1/2 Media, Image Left, 560px Max Height",
    variant: "variant_2",
    contentSide: "right",
    padding: true,
    fullBleedColor: true,
  },
  {
    option: "Side Margins, 1/2 Media, Image Right, 560px Max Height",
    variant: "variant_2",
    contentSide: "left",
    padding: true,
    fullBleedColor: true,
  },
  {
    /* eslint-disable no-multi-str */
    option: "Side Margins, 2/3 Media, Image Left, 304px Max Height",
    /* eslint-enable no-multi-str */
    variant: "variant_3",
    contentSide: "right",
    padding: true,
    fullBleedColor: true,
  },
  {
    option: "Side Margins, 2/3 Media, Image Right, 304px Max Height",
    variant: "variant_3",
    contentSide: "left",
    padding: true,
    fullBleedColor: true,
  },
  {
    option: "Side Margins, Image Only, 490px Max Height",
    variant: "variant_6",
    contentSide: "top",
    padding: true,
    fullBleedColor: true,
  },
  {
    option: "Side Margins, Media Top",
    variant: "variant_6",
    contentSide: "bottom",
    padding: true,
    fullBleedColor: true,
  },
  {
    option: "Side Margins, Media Bottom",
    variant: "variant_6",
    contentSide: "top",
    padding: true,
    fullBleedColor: true,
  },
  {
    option: "Side Margins, 2/3 Media, Video Left, 450px Max Ht",
    variant: "variant_7",
    contentSide: "right",
    padding: true,
    fullBleedColor: true,
  },
  {
    option: "Side Margins, 2/3 Media, Video Right, 450px Max Ht",
    variant: "variant_7",
    contentSide: "left",
    padding: true,
    fullBleedColor: true,
  },
  {
    option: "Full Width, 1/2 Media, Image Left, 720px Max Height",
    variant: "variant_8",
    contentSide: "left",
    padding: false,
    fullBleedColor: true,
  },
  {
    option: "Full Width, 1/2 Media, Image Right, 720px Max Height",
    variant: "variant_8",
    contentSide: "right",
    padding: false,
    fullBleedColor: true,
  },
  {
    option: "Full Width, 2/3 Media, Image Left, 720px Max Height",
    variant: "variant_10",
    contentSide: "left",
    padding: false,
    fullBleedColor: true,
  },
  {
    option: "Full Width, 2/3 Media, Image Right, 720px Max Height",
    variant: "variant_10",
    contentSide: "right",
    padding: false,
    fullBleedColor: true,
  },
  {
    option: "Side Margins, 2/3 Media, Image Left, 405px Max Height, Inset",
    variant: "variant_1",
    contentSide: "right",
    padding: true,
    fullBleedColor: false,
    verticalSpacingChild: true,
  },
  {
    option: "Side Margins, 2/3 Media, Image Right, 405px Max Height, Inset",
    variant: "variant_1",
    contentSide: "left",
    padding: true,
    fullBleedColor: false,
    verticalSpacingChild: true,
  },
  {
    option: "Side Margins, 1/2 Media, Image Right, 304px Max Height, Inset",
    variant: "variant_3",
    contentSide: "left",
    padding: true,
    fullBleedColor: false,
    verticalSpacingChild: true,
  },
  {
    option: "Side Margins, 1/2 Media, Image Left, 304px Max Height, Inset",
    variant: "variant_3",
    contentSide: "right",
    padding: true,
    fullBleedColor: false,
    verticalSpacingChild: true,
  },
  {
    option: "Side Margins, 1/2 Media, Image Left, 560px Max Height, Inset",
    variant: "variant_2",
    contentSide: "right",
    padding: true,
    fullBleedColor: false,
    verticalSpacingChild: true,
  },
  {
    option: "Side Margins, 1/2 Media, Image Right, 560px Max Height, Inset",
    variant: "variant_2",
    contentSide: "left",
    padding: true,
    fullBleedColor: false,
    verticalSpacingChild: true,
  },

  {
    option: "Side Margins, Image Only, 490px Max Height, Inset",
    variant: "variant_6",
    contentSide: "top",
    padding: true,
    fullBleedColor: false,
    verticalSpacingChild: true,
  },
  {
    option: "Side Margins, Media Bottom, Inset",
    variant: "variant_6",
    contentSide: "top",
    padding: true,
    fullBleedColor: false,
    verticalSpacingChild: true,
  },
  {
    option: "Side Margins, Media Top, Inset",
    variant: "variant_6",
    contentSide: "bottom",
    padding: true,
    fullBleedColor: false,
    verticalSpacingChild: true,
  },
]
